import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Necesito experiencia previa para usar este material?',
    a: 'No. El contenido está pensado para que cualquier persona pueda empezar desde cero. Tiene explicaciones paso a paso, planos detallados y material organizado de forma progresiva.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después de tu pago recibís un email con el enlace de descarga. Acceso instantáneo las 24 horas.'
  }, {
    q: '¿Puedo comprar desde cualquier país?',
    a: 'Sí. Está disponible para toda Latinoamérica y el mundo. El precio está en dólares y se convierte automáticamente a tu moneda local.'
  }, {
    q: '¿Es seguro comprar acá?',
    a: 'Sí. Usamos una plataforma de pago segura con encriptación de datos. Tu información está protegida en todo momento.'
  }, {
    q: '¿Por cuánto tiempo tengo acceso?',
    a: 'Para siempre. Pagás una sola vez y el material es tuyo de por vida. Sin suscripciones ni pagos adicionales.'
  }, {
    q: '¿El material es físico o digital?',
    a: 'Es 100% digital en formato PDF. Podés descargarlo y usarlo desde tu celular, tablet o computadora sin necesidad de conexión a internet una vez descargado.'
  }, {
    q: '¿Qué pasa si no me convence?',
    a: 'Tenés 7 días de garantía total. Si no te convence te devolvemos el 100% de tu dinero sin ninguna complicación.'
  }];
  return <section className="bg-brand-surface text-brand-text px-4 py-10" data-id="element-38">
      <div className="max-w-xl mx-auto" data-id="element-39">
        <h2 className="text-xl md:text-2xl font-black text-center mb-6 text-yellow" data-id="element-40">
          PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-2.5" data-id="element-41">
          {faqs.map((faq, index) => <div key={index} className="bg-brand-card border border-brand-border rounded-lg overflow-hidden" data-id="element-42">
              <button className="w-full px-4 py-3 text-left flex justify-between items-center" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-43">
                <span className="font-bold text-sm text-white pr-3" data-id="element-44">
                  ❓ {faq.q}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-yellow shrink-0" data-id="element-45" /> : <ChevronDown className="w-5 h-5 text-brand-muted shrink-0" data-id="element-46" />}
              </button>
              {openIndex === index && <div className="px-4 pb-4" data-id="element-47">
                  <p className="text-sm text-brand-muted leading-relaxed pt-2 border-t border-brand-border" data-id="element-48">
                    {faq.a}
                  </p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}